/** Generated by @gh/common callable client codegen. Do not edit manually. */

import type { CallableApiConfig, RouteTypeMap } from "@gh/common/callable-client";
import type { CheckEmailExistsRequest, CheckEmailExistsResponse, CheckReferralCodeRequest, CheckReferralCodeResponse, CreateGoogleUserRequest, CreateGoogleUserResponse, SignUpRequest, SignupMutationResponse, SignupNoopRequest, SignupNoopResponse, SignupResponse, UpdateUserPaidStatus, UpdateUserRequest, UpdateUserSignupFlowCompletedRequest, ValidateBrandingCodeRequest, ValidateBrandingCodeResponse } from "../../src/types";



export interface SignupRouteTypeMap extends RouteTypeMap {
  checkEmailExists: {
    request: CheckEmailExistsRequest;
    response: CheckEmailExistsResponse;
  };
  checkReferralCode: {
    request: CheckReferralCodeRequest;
    response: CheckReferralCodeResponse;
  };
  createGoogleUser: {
    request: CreateGoogleUserRequest;
    response: CreateGoogleUserResponse;
  };
  noop: {
    request: SignupNoopRequest;
    response: SignupNoopResponse;
  };
  signup: {
    request: SignUpRequest;
    response: SignupResponse;
  };
  updateUser: {
    request: UpdateUserRequest;
    response: SignupMutationResponse;
  };
  updateUserPaidStatus: {
    request: UpdateUserPaidStatus;
    response: SignupMutationResponse;
  };
  updateUserSignupFlowCompleted: {
    request: UpdateUserSignupFlowCompletedRequest;
    response: SignupMutationResponse;
  };
  validateBrandingCode: {
    request: ValidateBrandingCodeRequest;
    response: ValidateBrandingCodeResponse;
  };
}

export const signupApiConfig = {
  gatewayName: "signup_default_gateway",
  routes: {
    checkEmailExists: {
      gateway: "signup_default_gateway",
      action: "checkEmailExists",
    },
    checkReferralCode: {
      gateway: "signup_default_gateway",
      action: "checkReferralCode",
    },
    createGoogleUser: {
      gateway: "signup_default_gateway",
      action: "createGoogleUser",
    },
    noop: {
      gateway: "signup_default_gateway",
      action: "noop",
    },
    signup: {
      gateway: "signup_default_gateway",
      action: "signup",
    },
    updateUser: {
      gateway: "signup_default_gateway",
      action: "updateUser",
    },
    updateUserPaidStatus: {
      gateway: "signup_default_gateway",
      action: "updateUserPaidStatus",
    },
    updateUserSignupFlowCompleted: {
      gateway: "signup_default_gateway",
      action: "updateUserSignupFlowCompleted",
    },
    validateBrandingCode: {
      gateway: "signup_default_gateway",
      action: "validateBrandingCode",
    },
  },
} as const satisfies CallableApiConfig<SignupRouteTypeMap>;
